import { render, staticRenderFns } from "./TheMedia.vue?vue&type=template&id=0c7fc6cc&scoped=true"
import script from "./TheMedia.vue?vue&type=script&lang=ts"
export * from "./TheMedia.vue?vue&type=script&lang=ts"
import style0 from "./TheMedia.vue?vue&type=style&index=0&id=0c7fc6cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7fc6cc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ShowMediaTheNewTour: require('/usr/src/nuxt-app/components/show/media/TheNewTour.vue').default,ShowMediaTheVideo: require('/usr/src/nuxt-app/components/show/media/TheVideo.vue').default})
